import React from "react"
import { Link } from "gatsby"
import SideBarMenu from "../sidebar/sidebar"
import Sticky from "react-sticky-el"
import { stickyWrapper, isSticky, header } from "./header.module.css"
import HorizontalMenu from "../sidebar/horizontalmenu"
import { StaticImage } from "gatsby-plugin-image"
import { DropdownButton, Dropdown, ButtonGroup } from "react-bootstrap"

const Header = () => (
  <header>
    <Sticky
      className={stickyWrapper}
      stickyClassName={isSticky}
      stickyStyle={{ transform: "unset", zIndex: "2" }}
    >
      <div className={`header ${header} box-shadow`}>
        <div className="container">
          <div className="row my-4 top-menu d-lg-flex d-md-flex d-none">
            <div className="col-md-4">
              <DropdownButton
                id="dropdown-item-button"
                title="Our Companies"
                className="hmenu-button"
              >
                <div className="dropdown-item d-flex justify-content-center">
                  <a href="https://www.resthaven.xyz/" target="_blank">
                    Resthaven
                  </a>
                </div>
              </DropdownButton>
            </div>
            <div className="col-md-8 d-none d-lg-inline d-md-none">
              <div className="h-top-menu align-items-center d-flex justify-content-end border-bottom pb-2">
                {/* <Link to="/" className="me-4">
                  <svg
                    width="19"
                    height="19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="me-2"
                  >
                    <path
                      d="M8 16a7.952 7.952 0 0 0 4.897-1.688l4.396 4.396 1.414-1.414-4.396-4.396A7.952 7.952 0 0 0 16 8c0-4.411-3.589-8-8-8S0 3.589 0 8s3.589 8 8 8ZM8 2c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6 2.691-6 6-6Z"
                      fill="#323232"
                    />
                  </svg>
                  Search
                </Link> */}
                <Link to="/contact" className="me-4">
                  <svg
                    width="24"
                    height="26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="me-2"
                  >
                    <path
                      d="M2.625 5.625h18.75v14.25H2.625V5.625Z"
                      stroke="#323232"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="m3.375 6.375 8.625 7.5 8.625-7.5"
                      stroke="#323232"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Contact Us
                </Link>
                <Link to="/client-login">
                  <svg
                    width="18"
                    height="19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="me-2"
                  >
                    <path
                      d="M9 0a5 5 0 1 0 0 10A5 5 0 0 0 9 0Zm0 8a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm9 11v-1a7 7 0 0 0-7-7H7a7 7 0 0 0-7 7v1h2v-1a5 5 0 0 1 5-5h4a5 5 0 0 1 5 5v1h2Z"
                      fill="#323232"
                    />
                  </svg>
                  Investor Login
                </Link>
              </div>
            </div>
          </div>
          <div className="row justify-content-between align-items-center">
            <div className="col-auto">
              <div className="header-logo">
                <Link to="/">
                  <span className="display-4 text-white">
                    <StaticImage
                      className="my_logo_img"
                      src="../../images/logo-white.png"
                    />
                  </span>
                </Link>
              </div>
            </div>
            <div className="col-auto d-none d-lg-flex align-items-center">
              <HorizontalMenu />
            </div>
            {/* <div className="col-auto ml-auto d-none d-md-inline d-lg-inline">
              <Link to="/client-login/" className="my_btn_login">
                <StaticImage
                  src="../../images/user_icon.svg"
                  className="mr-sm-1"
                />
                LOG IN
              </Link>
            </div> */}
            <div className="col-auto d-inline d-lg-none pl-0">
              <SideBarMenu />
            </div>
          </div>
        </div>
      </div>
    </Sticky>
  </header>
)

export default Header
